import { RouterProvider } from "@tanstack/react-router";
import { useAuth } from "./lib/auth";
import { Login } from "./pages/Login";
import { router } from "./router";

export function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="grid h-full place-items-center text-sm text-foreground/60">
        loading…
      </div>
    );
  }

  return user ? <RouterProvider router={router} /> : <Login />;
}
